import SearchView from '../views/SearchView.vue';
import CompareView from '../views/CompareView.vue';

export default [
  {
    path: '/',
    name: 'home',
    component: SearchView,
  },
  {
    path: '/categorie/:taxonPermalink(.*)',
    name: 'categoryFR',
    component: SearchView,
  },
  {
    path: '/category/:taxonPermalink(.*)',
    name: 'categoryEN',
    component: SearchView,
  },
  {
    path: '/comparer',
    name: 'compareFR',
    component: CompareView,
  },
  {
    path: '/compare',
    name: 'compareEN',
    component: CompareView,
  },
];
